import { init, RematchRootState } from '@rematch/core';
import immerPlugin from '@rematch/immer';
import loadingPlugin from '@rematch/loading';
import * as Sentry from '@sentry/browser';
import { createEpicMiddleware } from 'redux-observable';
import createSentryMiddleware from 'redux-sentry-middleware';

import { admin } from 'src/modules/admin/rematchModels/admin';
import { assessments } from 'src/modules/assessments/rematchModels/assessments';
import { authentication } from 'src/modules/auth/rematchModels/authentication';
import { countries } from 'src/modules/countries/rematchModels/countries';
import { goalCategories } from 'src/modules/goals/rematchModels/goalCategories';
import { goalInterests } from 'src/modules/goals/rematchModels/goalInterests';
import { languages } from 'src/modules/languages/rematchModels/languages';
import { meditation } from 'src/modules/meditations/rematchModels/meditation';
import { cbtProgram } from 'src/modules/programs/cbtProgram/reducers/cbtProgramReducer';
import { cpProgram } from 'src/modules/programs/cpProgram/reducers/cpProgramReducer';
import { feedbacks } from 'src/modules/programs/feedback/reducers/feedbackReducer';
import { pfaProgram } from 'src/modules/programs/pfaProgram/reducers/pfaProgramReducer';
import { programs } from 'src/modules/programs/reducers/programsReducer';
import { surveys } from 'src/modules/programs/surveys/reducers/surveysReducer';
import { providers } from 'src/modules/providers/rematchModels/providers';
import { scheduledContent } from 'src/modules/scheduledContent/rematchModels/scheduledContent';
import { featureFlags } from 'src/modules/user/rematchModels/featureFlags';
import { user } from 'src/modules/user/rematchModels/user';
import { videos } from 'src/modules/videos/reducers/videosReducer';
import { videoSessions } from 'src/modules/videoSessions/rematchModels/videoSessions';

import { AppState } from './appState';
import { rootEpic } from './rootEpic';

const epicMiddleware = createEpicMiddleware(rootEpic);
const sentryMiddleware = createSentryMiddleware(Sentry);

const models = {
    authentication,
    providers,
    goalCategories,
    assessments,
    goalInterests,
    meditation,
    user,
    featureFlags,
    videoSessions,
    countries,
    languages,
    admin,
    scheduledContent,
};

export const initConfig = {
    models,
    redux: {
        // LEGACY: TO BE REMOVED WHEN MIGRATION FROM REDUX-OBSERVABLES TO REDUX-REMATCH FINISHED
        reducers: {
            programs,
            surveys,
            feedbacks,
            cpProgram,
            pfaProgram,
            cbtProgram,
            videos,
        },
        middlewares: [epicMiddleware, sentryMiddleware],
    },
    plugins: [immerPlugin(), loadingPlugin({})],
};

export const store = init(initConfig);

export type Store = typeof store;
export type Dispatch = typeof store.dispatch;
export type RematchModels = RematchRootState<typeof models>;

interface LoadingPlugin {
    loading: {
        models: RematchModels;
        effects: Dispatch;
    };
}
export type RootState = RematchModels & LoadingPlugin & AppState;
